module.exports = {"id":"157304","name":"Thomas Vermaelen","rating":"78","photo":"./data/images/photos/4/157304.png","club":{"name":"FC Barcelone","logo":"./data/images/clubs/FCBarcelone.png"},"positions":["DC","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ThomasVermaelen0.json
// module id = 4118
// module chunks = 0